import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from '@mui/icons-material/Done';
import { cn } from "@fmc-digital/ui";
import {
  passwordRequirementIndicatorStyles,
  passwordRequirementIndicatorTextStyles,
  passwordRequirementIndicatorIconStyles,
} from "./password-requirement-indicator.styles";
import type { PasswordRequirementIndicatorProps } from "./password-requirement-indicator.types";

/**
 * PasswordRequirementIndicator Atom
 * Displays a single password requirement with icon (X or plain checkmark) and text
 * Pure presentation component with no business logic
 */
export const PasswordRequirementIndicator: React.FunctionComponent<
  PasswordRequirementIndicatorProps
> = ({ requirement, isMet, className, testId }) => {
  return (
    <div
      className={cn(passwordRequirementIndicatorStyles(), className)}
      data-testid={testId ?? "password-requirement-indicator"}
    >
      <div className={cn(passwordRequirementIndicatorIconStyles())}>
        {isMet ? (
          <DoneIcon
            className="size-2.5 text-tertiary"
            data-testid={`${testId ?? "password-requirement-indicator"}-check`}
            aria-hidden="true"
          />
        ) : (
          <CloseIcon
            className="size-2.5 text-outline"
            data-testid={`${testId ?? "password-requirement-indicator"}-close`}
            aria-hidden="true"
          />
        )}
      </div>
      <span
        className={cn(passwordRequirementIndicatorTextStyles({ isMet }))}
        data-testid={`${testId ?? "password-requirement-indicator"}-text`}
      >
        {requirement}
      </span>
    </div>
  );
};
